import { Injectable } from '@angular/core';
import { Adapter } from '@app/core/adapter';
import { CountryAdapter } from '@app/core/services/country/country.adapter';
import { Asset } from '@app/shared/models/asset.model';
import { ModelAdapter } from './model.adapter';
import { Sensor } from '@app/shared/models/sensor.model';

@Injectable()
export class AssetAdapter implements Adapter<Asset> {
    constructor(private modelAdapter: ModelAdapter, private countryAdapter: CountryAdapter) {}

    adapt(data: any): Asset {
        return Object.assign(new Asset(), {
            id: data.id || data.assetId || 0,
            name: data.name || '',
            description: data.description || '',
            manufacturer: data.manufacturer || '',
            createdAt: data.createdAt || new Date(),
            imageUpdatedAt: data.imageUpdatedAt || new Date(),
            serial: data.serial || '',
            status: data.status || 0,
            customer: data.customer || '',
            customerAssetTagId: data.customerAssetTagId || '',
            databaseId: data.databaseId || '',
            groups: data.groups || [],
            tags: data.tags || [],
            location: this.getLocation(data.location),
            model: data.model || this.modelAdapter.adapt({}),
            hrefs: this.getRefs(data),
            subscribed: data.subscribed || false,
            subscription: data.subscription || '',
            recommendations: data.recommendations || false,
            deviceSerialNumber: data.deviceSerialNumber || null,
            sensor: this.getSensor(data.sensorModel),
        });
    }

    private getLocation(location: any) {
        return {
            address: location?.streetAddress || '',
            address2: location?.streetAddress2 || '',
            city: location?.city || '',
            state: location?.state || '',
            zip: location?.zip || '',
            country: location?.country || this.countryAdapter.adapt({}),
        };
    }

    private getRefs(data: any) {
        return {
            self: data.href || '',
            company: data.companyRef || '',
            model: data.parentModelId || '',
        };
    }

    private getSensor(data: any): Sensor {
        let sensor: Sensor = null;
        if (data) {
            sensor = {
                id: data.id,
                number: data.number,
                description: data.description,
                type: data.type,
                rating: data.rating,
                voltage: data.voltage,
            };
        }
        return sensor;
    }
}
